import React from 'react';
import { StoryWrapper } from '../StoryWrapper';
import styles from '../week-reflection.module.css';

export const PleasantnessIntro = ({ story, action, isPaused, config, storyData }) => {
    const heading = `Let's look at how your mood shifted through the week`;
    return (
        <StoryWrapper storyName={storyData.component} action={action} isPaused={isPaused}>
            <h1 className={styles.size2}>{heading}</h1>
        </StoryWrapper>
    );
}